module.exports = __webpack_public_path__ + "img/rspca.9676bdf.png";